<template>
    <div v-if="show" class="toast align-items-center border-0 toast-bottom-center toast-basket toast-cart show" id="toast_cart" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body">
                <i class="bi bi-basket2-fill"></i> Добавлено! <a href="/cart">Перейти в корзину</a>
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        show() {
            return this.$store.state.cart.addedToast;
        },
    },
};
</script>
